var render = function render() {
  var _vm = this,
    _c = _vm._self._c,
    _setup = _vm._self._setupProxy
  return _c(
    _setup.DraggablePopup,
    _vm._b(
      {
        attrs: { show: "", width: 400 },
        on: { "update:show": _setup.onUpdateShow },
        scopedSlots: _vm._u([
          {
            key: "title",
            fn: function () {
              return [
                _vm._v(
                  " " +
                    _vm._s(_setup.$map.trans("map.layer-control.info.title")) +
                    " "
                ),
              ]
            },
            proxy: true,
          },
        ]),
      },
      "DraggablePopup",
      _vm.$attrs,
      false
    ),
    [
      _c("div", { staticClass: "table-show-info" }, [
        _c("table", [
          _c(
            "tbody",
            _vm._l(_setup.props.option.fields, function (field, i) {
              return _c(_setup.TableTdLayer, {
                key: i,
                attrs: { field: field, layer: _setup.props.item },
              })
            }),
            1
          ),
        ]),
      ]),
    ]
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }